import React from 'react';
import styled from 'styled-components';

import { usePerx3Redesign } from 'hooks';

import { OrbitThemeVariant, orbitTokenDeclarationsFor } from './styles';

export interface IOrbitThemeScopeProps {
  children?: React.ReactNode;
  className?: string;
}

/**
 * `display: contents` is load-bearing. The panel wrapper is a flex child of the app's has-sider
 * row, and a scope with a box of its own would become that flex child instead and reflow the row;
 * with `contents` the wrapper stays the flex item while still inheriting the custom properties,
 * which are DOM-inherited rather than box-inherited.
 */
const ThemeScopeStyled = styled.div<{ $variant: OrbitThemeVariant }>`
  display: contents;

  ${({ $variant }) => orbitTokenDeclarationsFor($variant)}
`;

/** The variant the panel is rendering under, for the values that cannot be a `var()` reference. */
export const useOrbitThemeVariant = (): OrbitThemeVariant =>
  usePerx3Redesign() ? 'light' : 'dark';

/**
 * Declares the Orbit tokens on one element so every descendant resolves them. Inheritance is
 * DOM-based, so anything portalled out of this subtree (the two antd modals) needs its own copy.
 */
const OrbitThemeScope: React.FC<IOrbitThemeScopeProps> = ({ children, className }) => {
  const variant = useOrbitThemeVariant();

  return (
    <ThemeScopeStyled $variant={variant} className={className} data-testid="orbit-theme-scope">
      {children}
    </ThemeScopeStyled>
  );
};

export default OrbitThemeScope;
